
import './App.css';
import {
  MapContainer,
  TileLayer,
  Marker,
    GeoJSON
} from 'react-leaflet'
import {useMemo,useState,useRef,useEffect} from 'react';
import { DivIcon, Point} from 'leaflet';
import CanadaProvinces from './json/canada.json';

let lastMarkerOn;
let clickCheck = 0;
function App({context}) {
  const setMenuData = context?.setMenuData;
  const BaseMarker = (width,height,className,style) => {
    return new DivIcon({html:"<img src='marker-icon.png' style='"+style+"'></img>",className:className,iconAnchor:new Point(width/2,height),popupAnchor:new Point(0,-height),iconSize:new Point(width,height)})
  }
  function meetingDataToMenu(data) {
    return {
      title:data.name,
      latitude:data.latitude,
      longitude:data.longitude,
      info:[
        {name:"Name",
        data:data.name},
        {name:"Address",
        data:data.formatted_address},
        {name:"Location Page",
        data:<a href={data.url}>{data.url}</a>},
      ]
    }
  }
  const [meetingsData, setMeetingsData] = useState(false);


  useEffect(() => {
    fetch("https://aamanitoba.org/wp-admin/admin-ajax.php?action=meetings").then((res)=>(res.json())).then((json)=>{
      setMeetingsData(json);
    });

  }, []);

  context.closedMenu = ()=>{
    lastMarkerOn.classList.remove("selected");
  };

  function ClickableMarker({data,position}) {
    const markerRef = useRef(null)
    const eventHandlers = useMemo(
      () => ({
        click() {
          const marker = markerRef.current
          if (marker != null) {
            context.setMenuData(data);
            if (lastMarkerOn) {
              lastMarkerOn.classList.remove("selected");
            }
            lastMarkerOn = marker._icon;
            marker._icon.classList.add("selected");
          }
        },
      }),
      [data],
    )
    return (
      <Marker
      ref={markerRef}
      eventHandlers={eventHandlers}
      position={position}
      icon={BaseMarker(25,41,"","")} //filter: hue-rotate(143deg) contrast(1.7)
      >
      </Marker>
    )
  }
  
  function onDefaultClick(ele){
    if (ele) {

      ele.addEventListener("click",()=>{ 
        if (clickCheck + 100 < (new Date()).getTime()) {
          setMenuData(false); 
          if (lastMarkerOn) {
            lastMarkerOn.classList.remove("selected");
          } 
        }
      }); 
    }
  }
  function forEachFeature(feature,layer) {
    //layer.feature.properties.name
    const properties = layer.feature.properties;
    console.log(feature,layer)
    setTimeout(()=>{
    if(layer._path){
      layer._path.setAttribute("fill",feature.properties.fill);
      layer._path.setAttribute("fill-opacity",feature.properties["fill-opacity"]);
      layer._path.setAttribute("stroke",feature.properties["stroke"]);
      layer._path.setAttribute("stroke-opacity",feature.properties["stroke-opacity"]);
      layer._path.setAttribute("stroke-width",feature.properties["stroke-width"]);
    }},10);
    layer.addEventListener("click",()=>{
      clickCheck=(new Date()).getTime();
      if (lastMarkerOn?.classList) {
        lastMarkerOn.classList.remove("selected");
      } 
      console.log(layer)
      if (layer?._path?.classList) {
        lastMarkerOn = layer._path;
        layer._path.classList.add("selected");
      }
      layer._map.panInsideBounds(layer._bounds);
      context.setMenuData({
        title:properties.name,
        latitude:properties.lat,
        longitude:properties.lng,
        info:[
          {name:"Name",
          data:properties.name}
        ]
      });
    })
  }
  return (
    <MapContainer center={[53.455556, -96.9861109]} zoom={5} ref={onDefaultClick}>
      <TileLayer

        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {meetingsData && meetingsData.map((entry)=>(
        <ClickableMarker position={[entry.latitude,entry.longitude]} data={meetingDataToMenu(entry)}/>
      ))}
      
      <GeoJSON data={CanadaProvinces} onEachFeature={forEachFeature}/>
    </MapContainer>
  );
}

export default App;
